/**
 * Rôle : Container avec side barre
 * Copyright: © 2021 Remote Monkey S.A.S.U http://remote-monkey.fr
 */
import React from 'react';

export default function ContainerWithSideBarre(props) {
	const { children } = props;

	return (
		<div className="w-full flex-col flex lg:flex-row items-start justify-start my-5 md:my-20">
			{children}
		</div>
	);
}
